import React, { useMemo } from "react";
import "./participants.css";

type Participant = {
  logo: string;
  alt: string;
  link: string;
  whiteBgOn?: boolean;
};

const PARTICIPANTS = [
  {
    alt: "360 Treasury Systems AG",
    link: "https://360t.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1759868377/Participantlogos/IMG_0115_cocddt.png",
    whiteBgOn: false,
  },
  { alt: "ACIFMA", link: "https://langfritz.ch", logo: "", whiteBgOn: false },
  {
    alt: "AGB Bank",
    link: "https://www.agb.dz",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1759868610/Participantlogos/IMG_0116_j7fjp6.png",
    whiteBgOn: true,
  },
  {
    alt: "AL BARAKA",
    link: "https://albaraka-bank.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760357743/Participantlogos/albaraka-logo_nbh9uf.svg",
    whiteBgOn: false,
  },
  {
    alt: "AL SALAM BANK ALGERIA",
    link: "https://alsalamalgeria.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1759868609/Participantlogos/IMG_0118_w4c3qy.png",
    whiteBgOn: false,
  },
  {
    alt: "ALEXBANK",
    link: "https://alexbank.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385313/Participantlogos/ALEXBANK_Short_White_u71hlb.png",
    whiteBgOn: false,
  },
  {
    alt: "ALUBAF BANK",
    link: "https://alubafbank.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760357742/Participantlogos/alubaf-logo.png_hs0iju.png",
    whiteBgOn: false,
  },
  {
    alt: "ALUBAF INTERNATINAL BANK TUNIS",
    link: "https://alubaf.com.tn",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "ATTIJARIWAFA BANK",
    link: "https://attijariwafa.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Abu Dhabi Commercial Bank",
    link: "https://adcb.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Abu Dhabi Commercial Bank - Egypt",
    link: "https://adcb.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Albaraka Türk Katılım Bankası A. Ş.",
    link: "https://albarakaturk.com.tr",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Alex Bank",
    link: "https://alexbank.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Alsalam Bank Bahrain",
    link: "https://alsalambank.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385369/Participantlogos/Logo_z4v7yw.png",
    whiteBgOn: false,
  },
  {
    alt: "Arab International Bank",
    link: "https://aib.com.eg",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385315/Participantlogos/AIB_Logo_FF-03_q04uzl.png",
    whiteBgOn: false,
  },
  {
    alt: "Arab Islamic Bank",
    link: "https://aibnk.com",
    logo: "",
    whiteBgOn: false,
  },
  { alt: "AresBank", link: "https://aresbank.es", logo: "", whiteBgOn: false },
  {
    alt: "Attijariwafa bank",
    link: "https://attijariwafa.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385312/Participantlogos/CBK_LOGO_ap74xo.png",
    whiteBgOn: false,
  },
  {
    alt: "Attijariwafa bank -Egypt",
    link: "https://attijariwafa.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "BACB Bank",
    link: "https://bacb.co.uk",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385313/Participantlogos/bacb-logo-dark_jtlwo5.svg",
    whiteBgOn: true,
  },
  {
    alt: "BANCA UBAE SPA",
    link: "https://ubae.it",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "BANK OF JORDAN",
    link: "https://bankofjordan.com.jo",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "BANQUE CENTRALE POPULAIRE",
    link: "https://cpm.co.ma",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385315/Participantlogos/logo-gbp_lpmyeu.svg",
    whiteBgOn: true,
  },
  {
    alt: "BCP BANK",
    link: "https://groupebcp.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Bank ABC Egypt",
    link: "https://bank-abc.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385369/Participantlogos/Logo-abc-white_mgslgy.png",
    whiteBgOn: false,
  },
  {
    alt: "Bank NXT",
    link: "https://banknxteg.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385371/Participantlogos/logo-blue_zfrf41.png",
    whiteBgOn: false,
  },
  {
    alt: "Bank Of Africa",
    link: "https://www.bankofafrica.ma",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385371/Participantlogos/BANKOFAFRICA-LOGOO_argjsg.png",
    whiteBgOn: false,
  },
  {
    alt: "Bank Vontobel AG",
    link: "https://vontobel.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Bank of america",
    link: "https://bofa.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385370/Participantlogos/logo-bofa-flagscape-18ad22ccaf518c47d77b_r9g0ii.svg",
    whiteBgOn: true,
  },
  {
    alt: "Banque Misr",
    link: "https://banquemisr.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1761895674/Participantlogos/banquemisr-logo-v1_wrv8u3.png",
    whiteBgOn: true,
  },
  {
    alt: "Banque Misr UAE",
    link: "https://gulf-banquemisr.ae",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Banque du Caire",
    link: "https://bdc.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Belton fixed income brokerage",
    link: "https://beltoneholding.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Beltone Asset Management",
    link: "https://beltoneholding.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Beltone Securities Brokerage",
    link: "https://beltoneholding.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Blom Bank SAL",
    link: "https://blominvestbank.com",
    logo: "",
    whiteBgOn: false,
  },
  { alt: "CFG BANK", link: "https://cfgbank.com", logo: "", whiteBgOn: false },
  {
    alt: "CI Asset Management",
    link: "https://cicapital.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385314/Participantlogos/CICapitalSiteLogo-White_oiwisv.png",
    whiteBgOn: false,
  },
  {
    alt: "CREDIT AGRICOLE DU MAROC",
    link: "https://creditagricole.ma",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Cairo Amman Bank",
    link: "https://cab.jo",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Commercial Bank of Kuwait",
    link: "https://cbk.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Credit Agricole - Egypt",
    link: "https://ca-egypt.com",
    logo: "",
    whiteBgOn: false,
  },
  { alt: "Digitec", link: "https://digitec.de", logo: "", whiteBgOn: false },
  { alt: "EGBANK", link: "https://eg-bank.com", logo: "", whiteBgOn: false },
  {
    alt: "Egyptian Arab land Bank",
    link: "https://eal-bank.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Emirates Islamic Bank",
    link: "https://emiratesislamic.ae",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760390953/Participantlogos/emirates-islamic-logo_ltqnn6.svg",
    whiteBgOn: true,
  },
  {
    alt: "Emirates NBE Egypt",
    link: "https://emiratesnbd.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760390952/Participantlogos/logo_md2nno.svg",
    whiteBgOn: false,
  },
  {
    alt: "Fajr Investment Advisory B.S.C (c)",
    link: "https://fajr.com.bh",
    logo: "",
    whiteBgOn: false,
  },
  { alt: "GIB UK", link: "https://gibuk.com", logo: "", whiteBgOn: false },
  {
    alt: "Groupe Crédit agricole du Maroc",
    link: "https://creditagricole.ma",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Gulf International Bank UK",
    link: "https://gibuk.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Housing bank",
    link: "https://hbtf.com.jo",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Housing&Development bank",
    link: "https://hdb-egy.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "IBL Bank",
    link: "https://www.ibl.com.lb",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385370/Participantlogos/logo_skh3wp.png",
    whiteBgOn: false,
  },
  {
    alt: "Industrial Development Bank",
    link: "https://idbe.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Integral",
    link: "https://integral.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1758709919/INTEGRAL_Logo_Black_zzjwhi.png",
    whiteBgOn: true,
  },
  { alt: "Integral", link: "https://integral.com", logo: "", whiteBgOn: false },
  {
    alt: "Islamic Development Bank",
    link: "https://isdb.org",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "JORDAN KUWAIT BANK",
    link: "https://jkbank.com.jo",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Kuwait Financial Centre K.P.S.C.",
    link: "https://markaz.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "LIBYAN FOREIGN BANK",
    link: "https://lafbank.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "LSEG",
    link: "https://lseg.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1757613919/lseg_scwqth.png",
    whiteBgOn: false,
  },
  {
    alt: "Le crédit agricole du Maroc",
    link: "https://creditagricole.ma",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "MIDBank",
    link: "https://midbank.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "MISR ASSET MANAGEMENT",
    link: "https://mam-egypt.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Markaz",
    link: "https://markaz.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385369/Participantlogos/reverse-50y_o7juan.svg",
    whiteBgOn: false,
  },
  {
    alt: "Misr asset management",
    link: "https://mam-egypt.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "NATIONAL COMMERCIAL BANK",
    link: "https://ncb.ly",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385370/Participantlogos/logo_chcq5z.png",
    whiteBgOn: true,
  },
  {
    alt: "NATIONAL COMMERCIAL BANK",
    link: "https://ncb.ly",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "NATIONAL COMMERCIAL BANK .TRIPOLI.",
    link: "https://ncb.ly",
    logo: "",
    whiteBgOn: false,
  },
  { alt: "NBK", link: "https://nbk.com.eg", logo: "", whiteBgOn: false },
  {
    alt: "National Bank of Egypt, New York",
    link: "https://nbeny.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "National Bank of Kuwait",
    link: "https://nbk.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "National Bank of Kuwait S.A.K.P",
    link: "https://nbk.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385369/Participantlogos/nbk-logo_rwc5ws.svg",
    whiteBgOn: false,
  },
  {
    alt: "National bank of Egypt",
    link: "https://nbe.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Nexus",
    link: "https://globalittraders.com.au",
    logo: "",
    whiteBgOn: false,
  },
  { alt: "Quds Bank", link: "https://qudsbank.ps", logo: "", whiteBgOn: false },
  { alt: "SAHAM BANK", link: "https://socgen.com", logo: "", whiteBgOn: false },
  {
    alt: "SOHAR INTERNATIONAL SAOG",
    link: "https://sib.om",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385369/Participantlogos/Logo_245331cf55_w4pk5v.svg",
    whiteBgOn: false,
  },
  {
    alt: "Société Arabe Internationale de banque",
    link: "https://saib.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "Suez Canal Bank",
    link: "https://scbank.com.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "The United Bank",
    link: "https://theubeg.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "UBAF",
    link: "https://ubaf.fr",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1761896203/Participantlogos/ubaf_z8hg6r.png",
    whiteBgOn: false,
  },
  {
    alt: "United Gulf Bank B.S.C",
    link: "https://ugbbah.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "ZITOUNA BANK",
    link: "https://banquezitouna.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "banca ubae spa",
    link: "https://ubae.it",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "central bank of egypt",
    link: "https://cbe.org.eg",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "misr asset management",
    link: "https://mam-egypt.com",
    logo: "",
    whiteBgOn: false,
  },
  {
    alt: "quantara services",
    link: "https://www.quantaraservices.com",
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760385314/Participantlogos/ChatGPT_Image_Jul_19_2025_11_38_51_PM_od4jid.webp",
    whiteBgOn: true,
  },
  {
    alt: "the Housing Bank for Trade and Finance",
    link: "https://hbtf.com.jo",
    logo: "",
    whiteBgOn: false,
  },
];

const ParticipantsSection: React.FC = () => {
  // Only show participants with logos
  const visibleParticipants = useMemo(
    () => PARTICIPANTS.filter((p) => p.logo && p.logo.trim() !== ""),
    []
  );

  const sorted = useMemo(
    () => [...visibleParticipants].sort((a, b) => a.alt.localeCompare(b.alt)),
    [visibleParticipants]
  );

  const loop = useMemo(() => [...sorted, ...sorted], [sorted]);

  return (
    <section id="participants" className="ica-part-section">
      <div className="container">
        <div className="row">
          <div className="col-sm-8 col-sm-offset-2 mb-20 text-center">
            <h1 className="title">Participants</h1>
          </div>
        </div>

        <div
          className="ica-part-banner"
          aria-label="Participants logos carousel"
          role="region"
        >
          <div className="ica-part-marquee" tabIndex={0}>
            <ul className="ica-part-track" aria-hidden="false">
              {loop.map((x, i) => (
                <li className="ica-part-item" key={`${x.alt}-${i}`}>
                  <a
                    className={`ica-part-link ${
                      x.whiteBgOn ? "white-bg-on" : ""
                    }`}
                    rel="noopener noreferrer"
                    aria-label={x.alt}
                    title={x.alt}
                  >
                    <img src={x.logo} alt={x.alt} loading="lazy" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParticipantsSection;
